let accordionPanels = document.querySelectorAll('.wp-block-verve-blocks-accordion-panel');

accordionPanels.forEach((panel) => {
	panel.addEventListener('click', (e) => {
		e.target.parentNode.classList.toggle('is-open');
	});
});
